import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router-dom";
import { useApiresumeuploadapiMutation } from "../Store/Middleware/api/resumeUploadAPI";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import Cookies from "js-cookie";

export default function ResumeUpload({ isOpen, setIsOpen, token }) {
  const nav = useNavigate();
  const [apiResumeUpload, result] = useApiresumeuploadapiMutation();
  const [fileData, setFileData] = useState("");
  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [checkTerms, setCheckTerms] = useState(false);

  const pendingToken = localStorage.getItem("pendingAuthToken");
  const shouldBeOpen = isOpen.isResumeOpen || !!pendingToken;

  // ✅ UPDATED: handleClose ab kaam karta hai
  // Cross click karne par popup band hoga
  // aur pendingAuthToken bhi clean up hoga
  const handleClose = () => {
    localStorage.removeItem("pendingAuthToken");
    setIsOpen((prev) => ({
      ...prev,
      isSignupOpen: false,
      isOTPOpen: false,
      isResumeOpen: false,
      isAvatarOpen: false,
      hamburgerMenuOpen: false,
    }));
  };

  const handleResumeUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024);
      const fileExtension = file.name.split(".").pop()?.toLowerCase();

      if (fileSizeInMB > 6) {
        toast.error("File size exceeds the 6 MB limit.");
        return;
      }

      if (["pdf", "docx", "txt"].includes(fileExtension)) {
        setFileData(file);
      } else {
        toast.error(
          "Invalid file format. Only PDF, DOCX, or TXT files are allowed.",
        );
      }
    }
  };

  const handleSubmit = async () => {
    if (!fileData || !name || !number || !checkTerms) {
      toast.error("Please fill all the fields");
      return;
    }

    if (!name.match(/^[a-zA-Z]+(?: [a-zA-Z]+)*$/)) {
      toast.error("Invalid Name Entered");
      return;
    }

    const formData = new FormData();
    formData.append("resume", fileData);
    formData.append("candidate_id", localStorage.getItem("candidate_id"));

    const nameParts = name.split(" ");
    formData.append("first_name", nameParts[0]);
    formData.append(
      "last_name",
      nameParts.length > 1 ? nameParts.slice(1).join(" ") : "",
    );
    formData.append("mobile", number);
    formData.append("email", localStorage.getItem("userID") || "");

    try {
      const response = await apiResumeUpload(formData);
      if (response?.data?.success) {
        localStorage.setItem("name", name);
        localStorage.setItem("number", number);

        // Resume upload success — ab actual authToken set karo
        const finalToken = localStorage.getItem("pendingAuthToken") || token;
        Cookies.set("authToken", finalToken);

        // pendingAuthToken clean up
        localStorage.removeItem("pendingAuthToken");

        toast.success("Login successful!");

        setIsOpen((prev) => ({
          ...prev,
          isSignupOpen: false,
          isOTPOpen: false,
          isResumeOpen: false,
          isAvatarOpen: false,
          hamburgerMenuOpen: false,
        }));

        nav("/authPage/jobdetails/openposition");
      } else if (response?.error) {
        toast.error(response.error?.message || "Failed to upload resume");
      } else {
        toast.error("Unexpected error occurred");
      }
    } catch (error) {
      console.error("Error uploading resume:", error);
      toast.error(error.message || "Error occurred during upload");
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={shouldBeOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-title">
          {"Upload Your Resume"}
        </DialogTitle>
        <DialogContent dividers>
          <div className="input-group mb-3" style={{ paddingTop: "10px" }}>
            <input
              type="text"
              className="form-control"
              placeholder="Name"
              aria-label="Username"
              aria-describedby="basic-addon1"
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleSubmit();
                }
              }}
            />
          </div>
          <div className="input-group mb-3" style={{ paddingTop: "10px" }}>
            <PhoneInput
              defaultCountry="in"
              value={number}
              onChange={(phone) => setNumber(phone)}
              inputStyle={{ width: "100%" }}
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
                width: "100%",
                "--react-international-phone-country-selector-dropdown-width":
                  "30%",
              }}
            />
          </div>
          <div className="input-group mb-2" style={{ paddingTop: "5px" }}>
            <input
              type="text"
              className="form-control"
              placeholder="Email"
              value={localStorage.getItem("userID") || ""}
              disabled
              style={{ cursor: "not-allowed" }}
            />
          </div>
          <span style={{ color: "green", fontSize: "14px" }}>Verified</span>
          <div
            className="rounded-3 p-3"
            style={{
              borderStyle: "dashed",
              borderColor: "#165DFF",
              marginTop: "32px",
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <div
                  className="fw-bold"
                  style={{ fontSize: "16px", color: "#165DFF" }}
                >
                  Upload resume
                </div>
                <div
                  className="text-muted fw-bold"
                  style={{ fontSize: "14px" }}
                >
                  *Txt, Docx, PDF (Max file size-6MB)
                </div>
              </div>
              <Button
                component="label"
                variant="text"
                className="text-end rounded"
              >
                <label htmlFor="upload-button">
                  <FileUploadIcon
                    sx={{ cursor: "pointer", color: "#165DFF" }}
                  />
                </label>
                <input
                  type="file"
                  name="resume"
                  id="upload-button"
                  accept=".pdf, .docx, .txt"
                  style={{ display: "none" }}
                  onChange={handleResumeUpload}
                />
              </Button>
            </div>
          </div>
          {fileData && (
            <div className="mt-2" style={{ color: "grey" }}>
              {fileData.name}
            </div>
          )}
          <div className="resumeTextedmain">
            <div
              className="resumeTexted"
              style={{ display: "flex", gap: "10px" }}
            >
              <input
                type="checkbox"
                id="acceptTC"
                name="acceptTC"
                checked={checkTerms}
                onChange={() => setCheckTerms(!checkTerms)}
              />
              <label htmlFor="acceptTC">
                I accept Career Portal's T&Cs, Privacy Policy, and communication
                settings. You will be logged in with the email you've given
                above.
              </label>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          {result.isLoading ? (
            <Button disabled variant="contained">
              <CircularProgress color="inherit" />
            </Button>
          ) : (
            <Button
              onClick={handleSubmit}
              variant="contained"
              sx={{
                background: "#165DFF",
                "&:hover": { background: "#165DFF" },
              }}
            >
              Submit
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
